import React, { useState } from 'react';
import '../../styles/AdminModal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import useCategoryActions from '../../hooks/AdminCategoriesPage/useCategoryActions';

const CategoriesBulkDeleteModal = ({ isOpen, onClose, onSuccess, categories }) => {
  const [loading, setLoading] = useState(false);
  const { handleBulkDelete } = useCategoryActions();

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await handleBulkDelete(categories);
      await onSuccess();
      onClose();
    } catch (error) {
      console.error('Error deleting categories:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="admin__modal">
      <div className="admin__modal-content">
        <div className="admin__modal-intro">
          <h2>Delete Categories</h2>
          <button className="admin__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>
        <div className="admin__modal-body">
          <div className="admin__modal-body__delete_categories">
          <p>
            Are you sure you want to delete the following <strong>{categories.length} {categories.length === 1 ? 'category' : 'categories'}</strong>? 
            All products currently assigned to {categories.length === 1 ? 'this category' : 'these categories'} will be moved to the default <strong>Uncategorized</strong> category.
          </p>
            <div className="admin__modal-body__delete_categories_container">
              <ul>
                {categories.map(category => (
                  <li key={category.id}>
                    <strong>{category.name}</strong> (ID #{category.id})
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="admin__modal-buttons">
          <button className="button secondary" onClick={onClose} disabled={loading}>
            {loading ? 'Processing...' : 'Cancel'}
          </button>
          <button className="button" onClick={handleConfirm} disabled={loading}>
            {loading ? 'Processing...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CategoriesBulkDeleteModal;